<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row mt-1">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="company">
                <table class="w-full">
                  <thead style="background-color: #f7f9fc">
                    <tr>
                      <th style="padding: 12px"></th>
                      <th style="padding: 12px">Année N</th>
                      <th style="padding: 12px">Année N-1</th>
                      <th style="padding: 12px">Année N-2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="padding: 12px">Chiffre d'affaires</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanCA" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanCAN1" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanCAN2" type="number" />
                        </pr-input-column>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 12px">Total du bilan</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanTotalBilan"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanTotalBilanN1"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanTotalBilanN2"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 12px">Montant IR/IS payé</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanTax" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanTaxN1" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanTaxN2" type="number" />
                        </pr-input-column>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 12px">Résultat de l'exercice</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanNetResult"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanNetResultN1"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanNetResultN2"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 12px">Trésorerie stable</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanTresory" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanTresoryN1"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanTresoryN2"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 12px">Dette financière</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanDebt" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanDebtN1" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanDebtN2" type="number" />
                        </pr-input-column>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 12px">Fonds propres</td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input formControlName="bilanEquity" type="number" />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanEquityN1"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                      <td style="padding: 12px">
                        <pr-input-column
                          label=""
                          [derrors]="derrors"
                          [isDefault]="false"
                          suffix="€"
                        >
                          <input
                            formControlName="bilanEquityN2"
                            type="number"
                          />
                        </pr-input-column>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
